<template>
  <div class="wrap">
    <div class="payWrap ">
      <div class="titleBox">
        <img src="../assets/static/orgIcon.svg" class="orgIcon" />
        <div class="title">{{ institutionName }}</div>
      </div>
      <div class="moneyBox">
        <div class="title">支付金额</div>
        <div class="moneyInput">
          <div class="moneyIcon">￥</div>
          <input
            type="number"
            maxlength="10"
            v-model="paidInAmount"
            ref="numInput"
            @input="receiptsInput(paidInAmount)"
            autofocus="autofocus"
          />
        </div>
        <div class="noteBox">
          <div class="noteTitle">备注</div>
          <textarea
            class="textarea"
            maxlength="20"
            placeholder="请根据学校要求填写,限20字"
            v-model="remark"
          ></textarea>
        </div>
        <div class="limitNum">
          {{ remark.length }}/20
        </div>
      </div>
    </div>
    <div class="submitBox">
      <div class="text">由旭课支付提供服务支持</div>
      <div class="submitBtn" @click="clickPay">确定支付</div>
    </div>
  </div>
</template>

<script>
import { postPayMobileAPI } from "../utils/api/api";

export default {
  data() {
    return {
      paidInAmount: "", //支付金额
      remark: "", //备注
      institutionCode: "", //机构code
      institutionName: "", //机构名称
      payChannel: "", //支付方式
      openid: "", //微信openid
      buyerId: "", //支付宝id

      //   控制防重复提交变量
      submited: true,
    };
  },
  created() {
    if (window.localStorage.getItem("Payopenid")) {
      this.openid = window.localStorage.getItem("Payopenid");
      this.institutionCode = window.localStorage.getItem("institutionCode");
      this.institutionName = window.localStorage.getItem("institutionName");
      this.payChannel = window.localStorage.getItem("payChannel");
    }
  },
  mounted(){
      this.$nextTick(()=>{
          this.$refs.numInput.focus()
      })
      
  },
  methods: {
    receiptsInput(value) {
      var price = this.onlyPrice(this, value);
      this.paidInAmount = price;
    },
    clickPay() {
      console.log("123")
      if (!this.paidInAmount) {
        // this.$common.message(
        //   this,
        //   "error",
        //   this.$messageText.payMobile.noMoney
        // );
        this.$toast("请输入金额")
        return;
      }
      if (!this.submited) {
        // console.log('不能点击')
        return;
      }

      this.submited = false;
      var timer = setTimeout(() => {
        console.log("可点击");
        this.submited = true;
      }, 1000);
      // 微信支付
      if (this.payChannel == "W1") {
        var obj = {
          institutionCode: this.institutionCode,
          paidInAmount: this.paidInAmount,
          remark: this.remark,
          payChannel: this.payChannel,
          openid: this.openid,
        };
        console.log("微信支付提交的值", obj);
        postPayMobileAPI(obj).then((res) => {
          this.submited = true;
          clearTimeout(timer);
          if (res.resultCode == 200) {
            console.log("微信支付提交成功", res.data);
            function onBridgeReady() {
              if (res.data.wxJsPayParam != {}) {
                WeixinJSBridge.invoke(
                  "getBrandWCPayRequest",
                  {
                    appId: res.data.wxJsPayParam.appId,
                    timeStamp: res.data.wxJsPayParam.timeStamp,
                    nonceStr: res.data.wxJsPayParam.nonceStr,
                    package: res.data.wxJsPayParam.package,
                    signType: res.data.wxJsPayParam.signType,
                    paySign: res.data.wxJsPayParam.paySign,
                  },
                  function (res) {
                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                      // 使用以上方式判断前端返回,微信团队郑重提示：
                      //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                      this.$toast("支付成功")
                    }else{
                      this.$toast("支付失败")
                    }
                  }
                );
              }
            }
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener(
                  "WeixinJSBridgeReady",
                  onBridgeReady,
                  false
                );
              } else if (document.attachEvent) {
                document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
                document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
              }
            } else {
              onBridgeReady();
            }
          }
        });
      }




    },
    // 返回单价（不为负）
    onlyPrice(_this,value,maxValue=100000000,mes='',hasMes=true){ 
        value = value.toString()
        value=value.replace(/。/g,'.') // 中文情况下按点转换成英文的.
        console.log('value:',value)                          
        //得到第一个字符是否为负号    
        // var t = value.charAt(0);      
        //先把非数字的都替换掉，除了数字和.和-号    
        value = value.replace(/[^\d\.]/g,'');       
        //前两位不能是0加数字(若0 后加数字，则替换成数字)
        if(value.length >= 2) {
            var secNum = value.slice(1,2)
        }      
        value = value.replace(/^0\d[0-9]*/g,secNum); 
        //必须保证第一个为数字而不是.       
        value = value.replace(/^\./g,'');       
        //保证只有出现一个.而没有多个.       
        value = value.replace(/\.{2,}/g,'.');       
        //保证.只出现一次，而不能出现两次以上       
        value = value.replace('.','$#$').replace(/\./g,'').replace('$#$','.');  
        //如果第一位是负号，则允许添加    
        value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');
        if(Number(value) > Number(maxValue)) {
            if(hasMes) { // 有提示
                mes = mes ? mes : '最大不能超过'+maxValue
                // this.message(_this,'warning',mes)
                this.$toast(mes)
                value = value.slice(0,value.length-1)
            }else{ // 没提示，超过设为最大值
                value = maxValue
            }
            
        }
        return value
  
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  touch-action: pan-y;
}
.wrap {
  width: 100%;
  min-height: 100%;
  padding-bottom: 100px;
  box-sizing: border-box;
  position: relative;
  background: #f5f6f7;
  overflow: auto;
  -webkit-overflow-scrolling: auto;
  overflow-scrolling: auto;
}
.payWrap {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: calc(100% - 84px);
  font-size: 14px;
  touch-action: pan-y;
  .titleBox {
    padding: 13px 12px;
    box-sizing: border-box;
    margin-bottom: 10px;
    background: #FFFFFF;
    display: flex;
    flex-direction: row;
    align-items: center;
    .orgIcon {
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }
    .title{
        color: #3C4353;
        font-size: 16px;
    }
  }
  .moneyBox {
    padding: 16px;
    box-sizing: border-box;
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    .title {
      margin-bottom: 11px;
      color: #3C4353;
      font-size: 14px;
    }
    .moneyInput {
      height: 58px;
      border-bottom: 1px solid #ededed;
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      .moneyIcon {
        height: 24px;
        line-height: 24px;
        margin-right: 10px;
        color: #000000;
        font-weight: 500;
        font-size: 16px;
      }
      input {
        height: 58px;
        border: none;
        font-size: 52px;
        width: 100%;
      }
    }
    .noteBox {
      margin-top: 16px;
      display: flex;
      flex-direction: row;
      .noteTitle {
        min-width: 32px;
        margin-left: 12px;
        margin-right: 52px;
        font-size: 14px;
        color: #3C4353;
      }
      .textarea {
        height: 52px;
        resize: none;
        width: 100%;
        border: none;
        font-size: 14px;
        line-height: 21px;
      }
    }
    .limitNum {
      margin-right: 6px;
      color: #3C4353;
      font-size: 12px;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
    }
  }
}
.submitBox {
  width: 100%;
  height: 84px;
  background: #f5f6f7;
  position: absolute;
  bottom: 0px;
  display: flex;
  flex-direction: column;
  .text {
    height: 18px;
    line-height: 18px;
    margin-bottom: 16px;
    text-align: center;
    font-size: 12px;
    color: #838A9D;
  }
}
.submitBtn {
  width: 100%;
  height: 50px;
  line-height: 24px;
  background: #1a7af8;
  color: #FFFFFF;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
line-height: 50px;
  // margin: 16px 0;
}
</style>